import Info from './Info.vue';

export default Info;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/index.ts